<template>
  <div class="parent">
    <title-widge
      :title="title"
      :subTitle="subTitle"
    ></title-widge>

    <div class="divCourse">
      <el-collapse v-model="activeName" accordion @change="handleChange">
        <el-collapse-item
          v-for="(item, index) in datas"
          :key="index"
          :title="item.title"
          :name="index"
        >
          <div class="divContent" v-for="(v, k) in item.details" :key="k">
            <div class="divDetail">
              <div class="divTitle">{{ v.title }}</div>
              <div class="divItem">
                <div
                  class="divDetail"
                  v-for="(item1, index1) in v.details"
                  :key="index1"
                >
                  {{ item1 }}
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="divStudy" @click="qimoChatClick">
      <img src="./../img/learn.png"/>
      <span >马上学习</span>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";

export default {
  components: {
    titleWidge,
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  watch: {
  },
  data() {
    return {
      activeName: 0,
    };
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    qimoChatClick() {
      window.qimoChatClick();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/courseWidge.scss";
</style>
<style lang="scss">
.parent {
  .divCourse {
    .el-collapse-item__arrow {
      position: static !important;
    }
    .el-collapse-item__arrow,
    .el-icon-arrow-right:before,
    .el-icon-caret-right,
    .el-icon-caret-right:before {
      content: "\e6e0" !important;
      background: none;
    }
  }
}
</style>
